import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { getFieldsValidations } from '../../../api';
import { SettingsFrame } from '../../../components';
import { PasswordSettingsForm } from '../../../components/MainSettings/PasswordSettings';
import { ValidationResponse } from '../../../components/MainSettings/ValidationRule/types';
import { Preloader, ToDashboardError } from '../../../components/ui';
import { useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';

type RouteParams = { projectId: string; confPage: string };

const PasswordSettingsPage = ({ match, history }: RouteComponentProps): JSX.Element | null => {
  const { projectId } = match.params as RouteParams;
  const { currentProjectFetching, currentProjectType, currentProject, error } =
    useCurrentProject(projectId);
  const { navigationPath } = usePaths();
  const [fieldsValidation, setFieldsValidation] = useState<ValidationResponse>([]);
  const [fetchingFieldsValidation, setFetchingFieldsValidation] = useState<boolean>(true);

  useEffect(() => {
    getFieldsValidations(projectId).then((res) => {
      setFieldsValidation(res);
      setFetchingFieldsValidation(false);
    });
  }, []);

  if (error) {
    return <ToDashboardError error={error} pageName="password-settings_open" />;
  }

  if (currentProjectFetching || !currentProject) {
    return <Preloader />;
  }

  const backToNavigation = () =>
    currentProject.id && history.push({ pathname: navigationPath(currentProject.id) });

  return (
    <SettingsFrame projectId={currentProject.id} projectType={currentProjectType}>
      <PasswordSettingsForm
        projectId={projectId}
        currentProjectType={currentProjectType}
        backToNavigation={backToNavigation}
        fieldsValidation={fieldsValidation}
        setFieldsValidation={setFieldsValidation}
        fetchingFieldsValidation={fetchingFieldsValidation}
      />
    </SettingsFrame>
  );
};

export default withRouter(PasswordSettingsPage);
